import { Factory } from 'fishery';

import { CloudRoom } from '../cloud-room';

export const cloudRoomFactory = Factory.define<CloudRoom>(({ sequence }) => ({
	id: `cloud-room-${sequence}`,
	name: `Cloud Room ${sequence}`,
	creationDate: new Date(),
	health: {
		worstSeverity: undefined
	}
}));
